<template>
  <div class="container mb-60">
    <div class="wait-screen-awards">
      <img
        :src="trustpilot"
        alt="Trustpilot 4.8/5.0 Based on 10.716+ reviews"
        class="sm:mr-15 md:mx-30 lg:mx-0"
      >
      <img
        :src="feefo"
        alt="Feefo - Platinum Trusted Service Award"
        class="hidden sm:block md:mx-30 lg:mx-0"
      >
      <img
        :src="cio_review"
        alt="CIO Review - Most Promising FinTech Solution"
        class="hidden lg:block"
      >
    </div>
  </div>
</template>

<script>

export default {
  name: 'WaitScreenAwards',

  data () {
    return {
      cio_review: require('@/assets/img/wait-screen/cio_review.png'),
      feefo: require('@/assets/img/wait-screen/feefo.png'),
      trustpilot: require('@/assets/img/wait-screen/trustpilot.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.wait-screen-awards {
  @apply flex flex-row justify-center w-full;

  @screen lg {
    @apply justify-between;
  }
}
</style>
